import React from "react"
import { Component } from "react"
import { Link } from "react-router-dom"
// import FixProfileNavbar from "../../Components/Navbar/FixProfileNavbar";
import "../User2/UserProfile.css"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import AdminWrapper from "./AdminWrapper"

import TeacherInfoHeader from "./TeacherInfoHeader"
import Moment from "react-moment";
import { connect } from "react-redux"
import { API } from "../../API";
import { notify } from "react-notify-toast";
import Modal from "../../Components/Modal/Modal";
import PersonalForm2 from '../User2/PersonalForm2';
import TeacherInformationContainerByAdmin from "../Container/TeacherFormContainerByAdmin"
import { dateToISO } from "../../Helper";
import { Icon } from "semantic-ui-react";

// const
const cities = [
  { value: "Melbourne", label: "Melbourne" },
  { value: "Sydney", label: "Sydney" },
  { value: "Geelong", label: "Geelong" },
  { value: "Brisbane", label: "Brisbane" },
  { value: "Perth", label: "Perth" },
  { value: "Adelaide", label: "Adelaide" },
  { value: "GoldCost", label: "GoldCost" },
  { value: "Canberra", label: "Canberra" },
]

const tabs = [
  {
    pathname: '/',
    text: 'Personal Details',
    active: true,
  },
  // {
  //   pathname: '/emergencyContact',
  //   text: 'Emergency',
  // },
  // {
  //   pathname: "/preferredWorkLocations",
  //   text: "Work Locations",
  // },
];

export class TeacherpersonalDetails extends Component {
  constructor(props) {
    super(props)
    //console.log("props: "+ JSON.stringify(props))
    let user = JSON.parse(window.sessionStorage.getItem("admin-check-teacher")) || props.teacher;
    // let user = props.teacher
    // console.log("user: ", user)
    if (user === null) {
      window.location = "/login"
    }

    // const date_of_birth =
    //   user.date_of_birth !== null && user.date_of_birth !== undefined
    //     ? new Date(user.date_of_birth.split("T")[0]).getDate() +
    //     "-" +
    //     new Date(user.date_of_birth.split("T")[0]).getMonth() +
    //     1 +
    //     "-" +
    //     new Date(user.date_of_birth.split("T")[0]).getFullYear()
    //     : ""
    this.state = {
      user: user,
      first_name: user.first_name,
      last_name: user.last_name,
      preferred_name: user.preferred_name,
      showEditTeacherForm: false
    }
    //let formatted_date = current_datetime.getDate() + "-" + months[current_datetime.getMonth()] + "-" + current_datetime.getFullYear()

    /*francesca*/
    // this.setWatermarkedImage = this.setWatermarkedImage.bind(this);
  }

  setWatermarkedImage = (imgURL) => {
    // window.localStorage.setItem("imgURL", imgURL);
  }

  componentDidMount() {
    API.getTeacherDetailByID(this.state.user._id).then(res => {
      // console.log(this.state.user)
      // console.log(res)
      const detailedTeacherInfo = res.data.teacher
      console.log("detailedTeacherInfo: ", detailedTeacherInfo)
      const visa_expiry =
        detailedTeacherInfo.visa_expiry !== null && detailedTeacherInfo.visa_expiry !== undefined
          ? detailedTeacherInfo.visa_expiry.split("T")[0]
          : ""
      const police_check_release =
        detailedTeacherInfo.police_check_release !== null &&
        detailedTeacherInfo.police_check_release !== undefined
          ? detailedTeacherInfo.police_check_release.split("T")[0]
          : ""
      const wwcc_expiry =
        detailedTeacherInfo.wwcc_expiry !== null && detailedTeacherInfo.wwcc_expiry !== undefined
          ? detailedTeacherInfo.wwcc_expiry.split("T")[0]
          : ""
      this.setState({
        date_of_birth: detailedTeacherInfo.date_of_birth,
        user: detailedTeacherInfo,
        prefered_work_location: detailedTeacherInfo.prefered_work_location,
        default_work_location:
          detailedTeacherInfo.prefered_work_location !== null &&
          detailedTeacherInfo.prefered_work_location !== undefined
            ? detailedTeacherInfo.prefered_work_location.map((item) => {
              return { value: item, label: item }
            })
            : "Please select",
        preferred_online: detailedTeacherInfo.preferred_online,
        preferred_city1: detailedTeacherInfo.preferred_city1,
        preferred_city2: detailedTeacherInfo.preferred_city2,
        preferred_city3: detailedTeacherInfo.preferred_city3,
        contact_number: detailedTeacherInfo.contact_number,
        street_name: detailedTeacherInfo.street_name,
        street_number: detailedTeacherInfo.street_number,
        street_type: detailedTeacherInfo.street_type,
        unit_number: detailedTeacherInfo.unit_number,
        state: detailedTeacherInfo.state,
        suburb: detailedTeacherInfo.suburb,
        postcode: detailedTeacherInfo.postcode,

        /*francesca*/
        identification_document_number: detailedTeacherInfo.identification_document_number, // Passport/ Driving Licence number
        id_document_type: detailedTeacherInfo.id_document_type,
        id_document_expiry: detailedTeacherInfo.id_document_expiry,
        passport_country: detailedTeacherInfo.passport_country,
        identification_url: detailedTeacherInfo.identification_url,
        identification_filename: detailedTeacherInfo.identification_filename,
        visa_url: detailedTeacherInfo.visa_url,
        visa_filename: detailedTeacherInfo.visa_filename,
        visa_duration: detailedTeacherInfo.visa_duration,
        issuing_place: detailedTeacherInfo.issuing_place,
        subclass_name: detailedTeacherInfo.subclass_name,
        subclass_number: detailedTeacherInfo.subclass_number,
        issuing_office: detailedTeacherInfo.issuing_office,
        police_check_filename: detailedTeacherInfo.police_check_filename,
        police_check_url: detailedTeacherInfo.police_check_url,
        police_check_release: police_check_release,
        police_check_result: detailedTeacherInfo.police_check_result,
        police_check_type: detailedTeacherInfo.police_check_type,
        wwcc_filename: detailedTeacherInfo.wwcc_filename,
        wwcc_issuing_state: detailedTeacherInfo.wwcc_issuing_state,
        wwcc_url: detailedTeacherInfo.wwcc_url,
        wwcc_expiry: wwcc_expiry,
        wwcc_number: detailedTeacherInfo.wwcc_number,
        visa_file: {
          name: "",
          type: "",
          file: [],
        },
        visa_status: detailedTeacherInfo.visa_status,
        visa_type: detailedTeacherInfo.visa_type,
        visa_expiry: visa_expiry,
        visa_application_number: detailedTeacherInfo.visa_application_number,
        email: detailedTeacherInfo.email,
        displayVisaType:
          detailedTeacherInfo.visa_status !== null &&
          detailedTeacherInfo.visa_status !== undefined &&
          detailedTeacherInfo.visa_status === "I am Australian Citizen"
            ? "none"
            : "block",
        displayOther: "none",
        link_style: detailedTeacherInfo.identification_filename === null ? "none" : "block",
        visa_linkstyle: detailedTeacherInfo.visa_filename === null ? "none" : "block",
        policecheck_linkstyle:
          detailedTeacherInfo.police_check_filename === null ? "none" : "block",
        wwcc_linkstyle: detailedTeacherInfo.wwcc_filename === null ? "none" : "block",

        emergency_contact_name: detailedTeacherInfo.emergency_contact_name,
        emergency_contact_lastname: detailedTeacherInfo.emergency_contact_lastname,
        emergency_contact_mobile_number: detailedTeacherInfo.emergency_contact_mobile_number,
        emergency_contact_relationship: detailedTeacherInfo.emergency_contact_relationship,
        medical_needs: detailedTeacherInfo.medical_needs,
        referees: detailedTeacherInfo.referees,
        country: detailedTeacherInfo.country,
        region: detailedTeacherInfo.region,
        city: detailedTeacherInfo.city,
        address_line1: detailedTeacherInfo.address_line1,
        address_line2: detailedTeacherInfo.address_line2
      })
    }).catch(err => {
      console.log(err)
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const fields = [
      'first_name',
      'last_name',
      'middle_name',
      'preferred_name',
      'contact_number',
      'date_of_birth',
      'address_line1',
      'address_line2',
      'suburb',
      'state',
      'postcode',
      'prefered_work_location',
      'country',
      'region',
      'city'
     // 'whereby_link',
    ];
    let errors = false;

    const teacherData = {}

    for (let field of fields) {
      if (field !== 'prefered_work_location') {
        const input = document.getElementById(field);
        console.log(input)
        console.log("value: ", input?.value)
        if (!input.reportValidity()) {
          errors = true;
          break;
        }
        teacherData[field] = input?.value
      }
    }

    if (errors) {
      notify.show('You are missing one or more field(s)!');
    } else if (this.state.contact_number_verified === false) {
      notify.show('Please verify the contact number');
      errors = true;
    }

    if (!errors) {
      teacherData.date_of_birth = dateToISO(this.state.date_of_birth)
      console.log("Going to update: ", this.state, teacherData, dateToISO(this.state.date_of_birth))
      API.updateUserInfoByAdmin(teacherData, this.state.user._id).then((res) => {
        this.setState({showEditTeacherForm: false})
      })
    }
  };

  handleStateChange = (key, value) => {
    this.setState({ [key]: value });
    console.log(key + " insert " + value);
  };

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleNumberChange = (event) => {
    this.setState({value:event})
    this.setState({contact_number: event})
  }

  handleDateChange = (date) => {
    // saveDate(date)
    console.log("handleDateChange: ", date)
    this.setState({ date_of_birth: date });
  };

  onLocationChange = (location) => {
    this.setState({country: location.country });
    this.setState({region: location.region });
    this.setState({city: location.city });
  }

  render() {
    return (
      <AdminWrapper>
        <SwitchMenuBar isViewAsTeacher />

        <div className="auth-right d-lg-flex bg-photoregister ">
          <div className="bg-gradient"></div>
          <div className="profile-container">
            <div className="profile-content-card-area">
              <div className="tab-content clearfix">
                <TeacherInfoHeader user={this.state.user} />
                <div className="mt-5">

                  {/* navigationbar on top */}
                  <div className="userNavigation d-flex justify-content-between">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="user-links text-center d-flex  btn-primary primary-button-no-margin-hover text-white"
                    >
                      <p>BACK</p>
                    </Link>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            pathname: "/TeacherNotes"
                          }
                        }
                        className="user-links  d-flex user-links-background-transparent "
                      >
                        <p>Team Notes</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            // pathname: "/TeacherpersonalDetails"
                          }
                        }
                        className="user-links  user-links-active d-flex user-links-background-transparent "
                      >
                        <p>P.Info/I.D.</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherBanking",
                        }}
                        className="user-links text-center d-flex  "
                      >
                        <p>Banking</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/validatedocuments",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>Uploads</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherCalendar",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>Calendar</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherJoblistAdmin",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>JobList</p>
                      </Link>
                    </div>
                  </div>

                  {/* cpntent of the form */}
                  <div className="availability-table-container">
                    <div className="availability-table">
                      {/* container of the form */}
                      <div className="availability-table-body  mb-0 mt-5">
                        <div className="availability-table-body-content h-100">
                          <div className="container mt-3">
                            <div className="">
                              {/* TESTING BEFORE IMPLEMENTATION */}
                              <script src="https://cdn.jsdelivr.net/npm/places.js@1.16.4"></script>

                              <div className="">
                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    Personal Information
                                    <Icon
                                      name="pencil"
                                      className="mx-2 icon-asset material-icons-outlined cursor-pointer"
                                      size="large"
                                      color="#3bb4d8"
                                      onClick={() => this.setState({showEditTeacherForm: true})}
                                    />
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>
                                <div className="auth-text-top mb-3 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        First Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.first_name}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Email:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 line-height-24">
                                        {this.state.email}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Last Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.last_name}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6  my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0 line-height-24">
                                        Contact Number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17  text-capitalize line-height-24">
                                        {this.state.contact_number}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Preferred Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.preferred_name}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Date of Birth:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {/* {this.state.date_of_birth} */}
                                        {!!this.state.date_of_birth &&
                                          <Moment format="DD-MM-YYYY">{this.state.date_of_birth}</Moment>}
                                      </p>
                                      {/* console.log(new Date(user.date_of_birth).getDate()+); */}
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Preferred Work Locations:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {[this.state.preferred_online ? "Online" : false,
                                          this.state.preferred_city1,
                                          this.state.preferred_city2,
                                          this.state.preferred_city3].filter(Boolean).join(", ")}
                                        {/* {this.state.default_work_location} */}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Profile Status:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        INACTIVE
                                      </p>
                                    </div>
                                  </div>
                                  {/* <div className="form-group col-12 my-1 d-flex line-height-24"> */}
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Address Line1:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.address_line1}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Address Line2:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.address_line2}
                                      </p>
                                    </div>
                                  </div>
                                  {/* <div className="form-group col-12 my-1 d-flex line-height-24"> */}
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Suburb:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.suburb
                                          ? this.state.suburb
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  {/* <div className="form-group col-12 my-1 d-flex line-height-24"> */}
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Postcode:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.postcode
                                          ? this.state.postcode
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  {/* <div className="form-group col-12 my-1 d-flex line-height-24"> */}
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        State:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.state
                                          ? this.state.state
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    Referee Information
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>
                                {this.state.referees &&
                                  this.state.referees.length > 0
                                  ? this.state.referees.map(
                                    (referee, index) => {
                                      return (
                                        <div
                                          className="auth-text-top mb-5 row"
                                          key={index}
                                        >
                                          <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                            <label className=" line-height-24">
                                              <p className="text-left mb-0  line-height-24">
                                                First Name:
                                                </p>
                                            </label>
                                            <div className="input-icon ml-2 text-left line-height-24">
                                              <p className="font-17 text-capitalize  line-height-24">
                                                {referee.referee_first_name}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                            <label className=" line-height-24">
                                              <p className="text-left mb-0  line-height-24">
                                                Position:
                                                </p>
                                            </label>
                                            <div className="input-icon ml-2 text-left line-height-24">
                                              <p className="font-17 text-capitalize  line-height-24">
                                                {
                                                  referee.referee_position_title
                                                }
                                              </p>
                                            </div>
                                          </div>
                                          <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                            <label className=" line-height-24">
                                              <p className="text-left mb-0  line-height-24">
                                                Last Name:
                                                </p>
                                            </label>
                                            <div className="input-icon ml-2 text-left line-height-24">
                                              <p className="font-17 text-capitalize  line-height-24">
                                                {referee.referee_last_name}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                            <label className=" line-height-24">
                                              <p className="text-left mb-0  line-height-24">
                                                Organisation:
                                                </p>
                                            </label>
                                            <div className="input-icon ml-2 text-left line-height-24">
                                              <p className="font-17 text-capitalize  line-height-24">
                                                {referee.organisation}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                            <label className=" line-height-24">
                                              <p className="text-left mb-0  line-height-24">
                                                Email:
                                                </p>
                                            </label>
                                            <div className="input-icon ml-2 text-left line-height-24">
                                              <p className="font-17 text-capitalize  line-height-24">
                                                {referee.referee_email}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                            <label className=" line-height-24">
                                              <p className="text-left mb-0  line-height-24">
                                                Reference Check Form:
                                                </p>
                                            </label>
                                            <div className="input-icon ml-2 text-left line-height-24">
                                              <p className="font-17 text-capitalize  line-height-24">
                                                {referee.flag ? (
                                                  <a href={referee.url}>
                                                    View Here
                                                  </a>
                                                ) : (
                                                  "Waiting for complete"
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    }
                                  )
                                  : "No referee details found"}

                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    Emergency Contact
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>

                                <div className="auth-text-top mb-5 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        First Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.emergency_contact_name}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Last Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.emergency_contact_lastname}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Mobile number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {
                                          this.state
                                            .emergency_contact_mobile_number
                                        }
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Relationship:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {
                                          this.state
                                            .emergency_contact_relationship
                                        }
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-12 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Allergies / Medication / Conditions:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.medical_needs}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex mb-4">
                                  {/* if any information about the document is bad, such as, it's not valid or it's expired, it will have an alert linking to the validatedocuments page, and the expired writing will appear */}
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    {" "}
                                    Identification Document
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>
                                <div className="auth-text-top mb-3 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Residential Status:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.visa_status}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        {this.state.id_document_type} Number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {
                                          this.state
                                            .identification_document_number
                                        }
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        {this.state.visa_status ===
                                          "I am a visa holder"
                                          ? "Issuing Country"
                                          : "Issuing Australian State"}
                                        :
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.issuing_place}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        {this.state.id_document_type} Expiry
                                        Date:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      {/* if it's expired, it has .red class */}
                                      <p className="red font-17 text-capitalize  line-height-24 ">
                                        {this.state.id_document_expiry}{" "}
                                        Expired!!{" "}
                                      </p>
                                      {/* <p className="font-17 text-capitalize  line-height-24 ">{this.state.id_document_expiry}</p> */}
                                    </div>
                                  </div>
                                  <div className="form-group col-12  my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0 line-height-24">
                                        {this.state.id_document_type}:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <Link
                                        //onClick = {() => { this.setWatermarkedImage(this.state.identification_url)}}
                                        to={{
                                          // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?url=${this.state.identification_url}`,
                                          pathname: `https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?url=${this.state.identification_url}`,
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        {this.state.identification_filename}
                                      </Link>
                                    </div>
                                  </div>
                                </div>

                                {this.state.visa_status ===
                                  "I am a visa holder" ? (
                                  <>
                                    <div className="d-flex mb-4">
                                      <div className="light-blue-border mr-3"></div>{" "}
                                      <h5 className="mb-0 mt-3 w-fillava">
                                        Visa
                                      </h5>{" "}
                                      <div className="light-blue-border ml-3"></div>
                                    </div>

                                    <div className="auth-text-top mb-3 row">
                                      <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                        <label className=" line-height-24">
                                          <p className="text-left mb-0  line-height-24">
                                            Visa Application Number:
                                          </p>
                                        </label>
                                        <div className="input-icon ml-2 text-left line-height-24">
                                          <p className="font-17 text-capitalize  line-height-24">
                                            {this.state.visa_application_number}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                        <label className=" line-height-24">
                                          <p className="text-left mb-0  line-height-24">
                                            Type of Visa:
                                          </p>
                                        </label>
                                        <div className="input-icon ml-2 text-left line-height-24">
                                          <p className="font-17 text-capitalize  line-height-24">
                                            {this.state.visa_type}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                        <label className=" line-height-24">
                                          <p className="text-left mb-0  line-height-24">
                                            Subclass Name:
                                          </p>
                                        </label>
                                        <div className="input-icon ml-2 text-left line-height-24">
                                          <p className="font-17 text-capitalize  line-height-24">
                                            {this.state.subclass_name}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                        <label className=" line-height-24">
                                          <p className="text-left mb-0  line-height-24">
                                            Subclass Number:
                                          </p>
                                        </label>
                                        <div className="input-icon ml-2 text-left line-height-24">
                                          <p className="font-17 text-capitalize  line-height-24">
                                            {this.state.subclass_number}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                        <label className=" line-height-24">
                                          <p className="text-left mb-0  line-height-24">
                                            Issuing Country:
                                          </p>
                                        </label>
                                        <div className="input-icon ml-2 text-left line-height-24">
                                          <p className="font-17 text-capitalize  line-height-24">
                                            {this.state.issuing_office}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                        <label className=" line-height-24">
                                          <p className="text-left mb-0  line-height-24">
                                            Visa Expiry Date:
                                          </p>
                                        </label>
                                        <div className="input-icon ml-2 text-left line-height-24">
                                          <p className="font-17 text-capitalize  line-height-24">
                                            {this.state.visa_expiry}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="form-group col-12  my-1 d-flex line-height-24">
                                        <label className=" line-height-24">
                                          <p className="text-left mb-0 line-height-24">
                                            Visa:
                                          </p>
                                        </label>
                                        <div className="input-icon ml-2 text-left line-height-24">
                                          <Link
                                            // onClick = {() => { this.setWatermarkedImage(this.state.visa_url)}}
                                            to={{
                                              // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?url=${this.state.visa_url}`,
                                              pathname: `https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?url=${this.state.visa_url}`,
                                            }}
                                            className="profile-linkfont-12"
                                            target="_blank"
                                          >
                                            {this.state.visa_filename}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : null}

                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    Police Check
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>

                                <div className="auth-text-top mb-3 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Police Check Type:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.police_check_type}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Police Check Result:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.police_check_result}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Police Check Issuing Organisation:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {
                                          this.state
                                            .police_check_issuing_organisation
                                        }
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Police Check Release Date:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.police_check_release}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-12  my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0 line-height-24">
                                        Police Check:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <Link
                                        //  onClick = {() => { this.setWatermarkedImage(this.state.police_check_url)}}
                                        to={{
                                          // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?url=${this.state.police_check_url}`,
                                          pathname: `https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?url=${this.state.police_check_url}`,
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        {this.state.police_check_filename}
                                      </Link>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    Working With Children Check
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>

                                <div className="auth-text-top mb-5 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        WWCC Number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.wwcc_number}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        WWCC Issuing State:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.wwcc_issuing_state}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        WWCC Expiry Date:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.wwcc_expiry}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6  my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0 line-height-24">
                                        Working With Children Check:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <Link
                                        // onClick = {() => { this.setWatermarkedImage(this.state.wwcc_url)}}
                                        to={{
                                          // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?url=${this.state.wwcc_url}`,
                                          pathname: `https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?url=${this.state.wwcc_url}`,
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        {this.state.wwcc_filename}
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* submit button */}
                            {/*<div className="row pr-0 mr-0">
                                <div className="col-md-4"><Link
                                    type="teachers"
                                    value="Teachers"
                                    to="/AllTeachers"
                                    className="btn btn-block btn-c secondary-button-no-margin-hover"
                                  > All Teachers </Link></div>
                                 <div className="col-md-4 pr-0"></div>
                                <div className="col-md-4"><Link
                                    type="next"
                                    value="Next"
                                    to="/TeacherIdentification"
                                    className="btn btn-block btn-c secondary-button-no-margin-hover"
                                  > Next </Link></div>
                              </div>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* navigationbar on bottom */}
                  <div className="adminBottomNavigation ">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                    >
                      <p>BACK - All Teachers</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          header='Edit Teacher Detail'
          onClose={() => this.setState({showEditTeacherForm: false})}
          className=""
          show={this.state.showEditTeacherForm}
          size="lg"
        >
          <div className="mt-3">
            <div>
              <TeacherInformationContainerByAdmin
                header='Personal Information'
                tabs={tabs}
                handleSubmit={this.handleSubmit}
              >
                {
                  // console.log("this.state.date_of_birth: ", this.state.date_of_birth)
                  // saveDate(this.state.date_of_birth)
                }
                {(<PersonalForm2
                  handleStateChange={this.handleStateChange}
                  handleFormFieldChange={this.handleFormFieldChange}
                  handleDateChange={this.handleDateChange}
                  handleNumberChange={this.handleNumberChange}
                  state={this.state}
                />)}
                
              </TeacherInformationContainerByAdmin>
            </div>
          </div>
        </Modal>

      </AdminWrapper>
    )
  }
}

function mapStateToProps(state) {
  return {
    teacher: state.admin.teacher,
  }
}

export default connect(mapStateToProps)(TeacherpersonalDetails)
